import logLevel from "loglevel";

// webpack-dev-server also uses loglevel
// which makes it a singleton and overrides
// atgse settings. Namespacing it to avoid conflicts
export default logLevel.getLogger("atg");

export {default as serializeError} from "../serializeError";
export {default as serverLogPlugin} from "./serverLogPlugin";
